/**
 * The one name for the person who filed a feedback ticket.
 *
 * Name, then email, then "Anonymous". The same expression was written out
 * verbatim in five places — the table row, the digest card, the tenant
 * drawer, the super-admin detail pane and the public share page — so the
 * fallback could drift per surface, and nothing covered it: a repo-wide grep
 * for "Anonymous" across apps/web specs returns zero feedback hits. #703 gave
 * the table a column of its own, which made a single definition worth having.
 *
 * The `.trim()` is deliberate and IS a behaviour change from the old
 * expression: a whitespace-only name now falls through to the email instead
 * of rendering an empty cell. Inside a sentence that was invisible; in a
 * column of its own it reads as a bug.
 */
export function feedbackSubmitterLabel(t: {
  submittedByName?: string | null
  submittedByEmail?: string | null
}): string {
  return t.submittedByName?.trim() || t.submittedByEmail?.trim() || "Anonymous"
}
